export default __webpack_public_path__ + "static/media/PMT_Logo.560c8c9b.jpeg";